import Tone from 'tone';
export const equalTemperment = (num) => {
    let list = [];
    let x = 0.0;
    for (let i=0; i < num; i++) {
        list.push((num + i) / num);
    }
    return list;
};


export const frequencyToTranspose = (frequency) => {
    let midi = 69 + (12 * Math.log2(frequency / Tone.Frequency.A4));
    return midi - 60;
}
